export const Types = {
  ADD_PROPOSTAS: "filtrosPropostas/ADD_PROPOSTAS"
};

const INITIAL_STATE = {
  lojas: [],
  vendedores: [],
  vendedoresParticipantes: [],
  bancos: [],
  promotoras: [],
  produtos: [],
  operacoes: [],
  status: [],
  docs: [],
  accepted: [],
  data: "1-Data contrato",
  started_at: new Date(new Date().getFullYear(), new Date().getMonth()),
  finished_at: new Date(),
  has_receipt: [],
  bordero: []
};

export default function filtrosPropostas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_PROPOSTAS:
      return {
        ...state,
        lojas: action.payload.data.lojas,
        vendedores: action.payload.data.vendedores,
        vendedoresParticipantes: action.payload.data.vendedoresParticipantes,
        bancos: action.payload.data.bancos,
        promotoras: action.payload.data.promotoras,
        produtos: action.payload.data.produtos,
        operacoes: action.payload.data.operacoes,
        status: action.payload.data.status,
        docs: action.payload.data.docs,
        accepted: action.payload.data.accepted,
        data: action.payload.data.data,
        started_at: action.payload.data.started_at,
        finished_at: action.payload.data.finished_at,
        has_receipt: action.payload.data.has_receipt
      };
    case Types.CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
}

export const Creators = {
  addPropostasFiltro: data => ({
    type: Types.ADD_PROPOSTAS,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosPropostas.js